import SettingContentLayout from "layout/setting-content/SettingContentLayout";
import { useEffect, useState } from "react";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import SearchBar from "components/app/search-bar/SearchBar";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import { Button } from "components/ui/button";
import { AppRecord, AppRecordStatus } from "models/appRecord";
import { LoaderCircle } from "lucide-react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";
import { Card } from "components/ui/card";
import { profileVerified } from "assets";

export default function BlockAccounts() {
  const [accountLoading, setAccountLoading] = useState<any>(null);
  const [userAccount, setUserAccount] = useState<any>(null);
  const { token } = useAppSelector((state) => state.auth);
  const [searchText, setSearchText] = useState<string>("");
  const navigate = useNavigate();

  const accountState = {
    currentPage: 1,
    currentIndex: 0,
    nextPageUrl: "",
    totalRecord: 0,
    loadingStatus: AppRecordStatus.loading,
  };

  const fetchMoreGetAccount = async ({ next }: { next: string }) => {
    setAccountLoading({
      ...accountState,
      loadingStatus: AppRecordStatus.loadingMore,
    });

    await RequestApi(next).then((responses) => {
      if (responses.status === "success") {
        const stateRecord: AppRecord = {
          currentPage: 1,
          currentIndex: 0,
          nextPageUrl: responses["user_borings"]["next_page_url"] ?? "",
          totalRecord: 0,
          loadingStatus: responses["user_borings"]["next_page_url"] !== null ? AppRecordStatus.noLoadMore : AppRecordStatus.loaded,
        };

        const tmpPosts = [...userAccount["data"], ...responses["user_borings"]["data"]];

        const newPost = { ...userAccount, data: tmpPosts };
        setUserAccount(newPost);
        setAccountLoading(stateRecord);
      }
    });
  };

  const fetchGetAccount = async () => {
    try {
      let url: string = "";

      url = RouteApi.getBoringUser;
      url += `token=${token}`;

      const data = {
        search_text: searchText,
      };

      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            const stateRecord: AppRecord = {
              currentPage: 1,
              currentIndex: 0,
              nextPageUrl: responses["user_borings"]["next_page_url"] ?? "",
              totalRecord: 0,
              loadingStatus: responses["user_borings"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
            };

            setUserAccount(responses["user_borings"]);
            setAccountLoading(stateRecord);
          } else {
          }
        })
        .catch((err) => {});
    } catch (error) {
      AppLog.show({
        message: `[fetchGetAccount]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const onSubmit = async ({ userId }: { userId: string }) => {
    try {
      let url: string = "";
      url = RouteApi.submitRemoveBoringUser;
      url += `token=${token}`;

      const data = {
        user_id: userId,
      };

      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        const tmpUserAccount = { ...userAccount };
        tmpUserAccount.data = tmpUserAccount.data.filter((element: any) => element.id !== response.user.id);
        setUserAccount(tmpUserAccount);
      } else {
        AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
      }
    } catch (error) {
      AppLog.show({
        message: `[onSubmit]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  useEffect(() => {
    if (searchText === "") {
      fetchGetAccount();
    } else {
      fetchGetAccount();
    }

    // eslint-disable-next-line
  }, [searchText]);

  return (
    <SettingContentLayout>
      <div className="min-h-[calc(100vh-160px)] p-4">
        <div>
          <h1 className="text-lg font-semibold">Boring Accounts</h1>
          <p className="text-muted-foreground text-sm">Manage accounts that you find uninteresting to customize your feed and interactions.</p>
        </div>
        <div className="mt-4">
          <SearchBar onValueChange={(value) => setSearchText(value)} />
        </div>

        {userAccount ? (
          <>
            <InfiniteScroll
              className={`relative`}
              dataLength={userAccount["data"]?.length}
              next={() =>
                fetchMoreGetAccount({
                  next: accountLoading.nextPageUrl,
                })
              }
              hasMore={accountLoading.nextPageUrl === "" ? false : true}
              loader={
                <div className="absolute bottom-2 left-0 w-full flex justify-center">
                  <LoaderCircle size={30} className="animate-spin text-yellow-400" />
                </div>
              }
              endMessage={
                <p className="absolute bottom-0 left-0 w-full text-center">
                  <b>Nothing more to load!</b>
                </p>
              }
            >
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-16">
                {userAccount?.data?.map((user: any) => {
                  return (
                    <Card key={user.id} className="rounded-md space-y-2">
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          navigate(`/profile?id=${user?.id}&feed`);
                        }}
                      >
                        <ImageUrlProfile className="w-full object-cover h-[200px] rounded-t-md" user={user} isThumbnail={false} />
                        {/* Name */}
                        <div className="p-2">
                          <div className="flex">
                            <h1 className="font-semibold text-lg line-clamp-1">{user?.name}</h1>
                            {user?.is_verified === "Yes" ? (
                              <>
                                <div className="flex items-center justify-center pt-0.5 ml-1">
                                  <img src={profileVerified} style={{ width: 24, height: 24 }} alt="" />
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                          <p className={`line-clamp-1 ${user?.bio === "" ? "invisible" : ""}`}>{user?.bio !== "" ? user?.bio : "NoBio"}</p>
                        </div>
                      </div>

                      {/* Follower Post Like */}
                      <div className="grid grid-cols-3 text-center">
                        <div className="">
                          <h1 className="font-semibold">{user?.no_of_follower}</h1>
                          <p className="text-xs">Followers</p>
                        </div>
                        <div className="">
                          <h1 className="font-semibold">{user?.no_of_post}</h1>
                          <p className="text-xs">Posts</p>
                        </div>
                        <div className="">
                          <h1 className="font-semibold">{user?.no_of_like}</h1>
                          <p className="text-xs">Likes</p>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 p-2">
                        <Button onClick={() => onSubmit({ userId: user.id })} size={"sm"} className="text-white bg-red-500">
                          Remove
                        </Button>
                      </div>
                    </Card>
                  );
                })}
              </div>
            </InfiniteScroll>
          </>
        ) : (
          <></>
        )}
      </div>
    </SettingContentLayout>
  );
}
